<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    ref="mapRef"
    class="block-map"
    :style="`--color-map: ${color4}; --color-number:${color1};`"
  >
    <div class="block-map__map" v-html="data.svg_code" />

    <div class="block-map__countries">
      <div
        v-for="(item, index) of data.legend"
        :key="item._uid"
        class="block-map__country"
      >
        <div class="block-map__country-counter">
          {{ index + 1 }}
        </div>
        <div class="block-map__country-text">
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
    data: {
        type: Object,
        default: () => {},
    },
});

const mapRef = ref(null);

const colorTopLevel = inject('colorSchema');
const color1 = computed(() => `var(--c-${colorTopLevel.value}-1)`);
const color4 = computed(() => `var(--c-${colorTopLevel.value}-4)`);

onMounted(() => {
    window.setTimeout(() => {
        GSAP.from(['.number', '.block-map__country'], {
            opacity: 0,
            y: 80,
            duration: 1,
            ease: 'power2.out',
            stagger: 0.1,

            scrollTrigger: {
                trigger: mapRef.value,
                scrub: true,
                start: 'top 75%',
                end: 'top top',
            },
        });
    }, 200);
});
</script>

<style lang="scss">
.block-map {
    @include fluid('padding-right', 0px, 60px);
    @include fluid('padding-left', 0px, 60px);

    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    color: var(--parent-text-color, var(--c-white));

    svg {
        width: 100%;
        height: auto;
    }
}

.number,
.block-map__country {
    transform-origin: center center;
    will-change: transform, opacity;
}

.block-map__map {
    display: flex;
    width: 90%;
    height: auto;
    align-items: center;
    justify-content: center;
    margin-bottom: 45px;

    @include  mobile{
        width: 100%;
        margin-bottom: 30px;
    }
}

.block-map__svg {
    width: 100%;
}

.block-map__countries {
    display: grid;
    width: 80%;
    height: auto;
    align-items: center;
    grid-column-gap: 20px;
    grid-template-columns: repeat(4, 1fr);
    row-gap: 10px;

    @include tablet {
        grid-template-columns: repeat(3, 1fr);
    }

    @include mobile {
        width: 90%;
        grid-template-columns: repeat(2, 1fr);
        row-gap: 16px;
    }
}

.block-map__country {
    display: flex;
    column-gap: 10px;
}

.block-map__country-counter {
    display: flex;
    width: 25px;
    height: 25px;
    align-items: center;
    align-self: center;
    justify-content: center;
    padding-top: 1px;
    border-radius: 50%;
    background: var(--c-white);
    color: var(--parent-color-1, var(--c-white));
    font-family: var(--f-family--bold);
    font-size: 16px;
    font-weight: 700;
}

.block-map__country-text {
    @include fluid('font-size', 15px, 20px);
    @include fluid('line-height', 23px, 31px);
    align-self: center;
    font-family: var(--f-family--bold);
}
</style>
